import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Plaatselijk (buik)vet verbranden, is het mogelijk?
                </title>
                <link rel="canonical" href={route("blogs.thirty-five")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE Personal Training Uden en Schijndel komt met een nieuwe blog. In deze blog gaan we plaatselijk vet verbranden bespreken. We krijgen vaak de vraag of het mogelijk is om, voornamelijk buikvet plaatselijk te verbranden. Of dit mogelijk is bespreken we in deze nieuwe blog, lees je met ons mee?"
                />
                <meta
                    property="og:description"
                    content="WE ARE Personal Training Uden en Schijndel komt met een nieuwe blog. In deze blog gaan we plaatselijk vet verbranden bespreken. We krijgen vaak de vraag of het mogelijk is om, voornamelijk buikvet plaatselijk te verbranden. Of dit mogelijk is bespreken we in deze nieuwe blog, lees je met ons mee?"
                />
                <meta property="og:url" content={route("blogs.thirty-five")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Plaatselijk (buik)vet verbranden, is het mogelijk? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/plaagtselijk-vet-verbranden.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/plaatselijk-vet-verbranden.webp"
                                    type="image/webp"
                                    alt="Plaatselijk vet verbranden"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/plaatselijk-vet-verbranden.jpg"
                                    type="image/jpeg"
                                    alt="Plaatselijk vet verbranden"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/plaatselijk-vet-verbranden.jpg"
                                    alt="Plaatselijk vet verbranden"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Plaatselijk (buik)vet verbranden, is het mogelijk?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE Personal Training Uden en Schijndel komt met een
                        nieuwe blog. In deze blog gaan we plaatselijk vet
                        verbranden bespreken. We krijgen vaak de vraag of het
                        mogelijk is om, voornamelijk{" "}
                        <a
                            href={route("blogs.thirty-one")}
                            className="text-we-are-yellow"
                        >
                            buikvet
                        </a>{" "}
                        plaatselijk te verbranden. Of dit mogelijk is bespreken
                        we in deze nieuwe blog, lees je met ons mee?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe wordt vet verbrand?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Vet moet vrijgemaakt worden voordat het verbrand kan
                        worden. Hiervoor heeft het lichaam verschillende
                        hormonen nodig zoals adrenaline. Daarnaast heeft het
                        lichaam twee verschillende receptoren die een
                        belangrijke rol spelen in dit proces. De twee receptoren
                        zijn Alfa 2 en Beta 2 waarbij de laatstgenoemde het
                        vetvrij maakt. Alle vetcellen hebben deze twee
                        receptoren maar de probleemgebieden hebben meer Alfa 2
                        receptoren dan Bèta 2 receptoren zoals de buik en
                        heupen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Hoewel het niet ‘cool’ klinkt vormt de kern nog steeds
                        het aantal calorieën wat je eet ten opzichte van wat je
                        aan calorieën verbrand per dag. Wanneer je meer
                        calorieën verbrandt dan eet kom je terecht in een
                        negatieve energiebalans en zolang je dit maar lang
                        genoeg volhoudt zullen ook de hardnekkige delen vet vrij
                        maken zodat dit verband kan worden.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Kun je dus plaatselijk vet verbranden?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Hoewel je op sociale media de meest gekke post tegenkomt
                        dat plaatselijk vet verbranden een optie is door{" "}
                        <a
                            href={route("blogs.seventeenth")}
                            className="text-we-are-yellow"
                        >
                            fatburners
                        </a>{" "}
                        of andere methodes, is het dus niet mogelijk. Laat je
                        dus niet verleiden door dit soort van marketing omdat
                        het je veel geld kost en ze het niet waar kunnen maken.
                        Het is dus een misvatting dat je plaatselijk vet kunt
                        verbranden. Het lichaam bepaalt namelijk zelf waar hij
                        vet zal verbranden. Dit beoordeelt hij aan de hand van
                        zijn overlevingskansen. Deze overlevingskansen wil het
                        lichaam zo hoog mogelijk houden.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat moet je dus doen om vet te verbranden?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Concluderend kunnen we zeggen dat plaatselijk vet
                        verbranden onmogelijk is. Het is een kwestie van minder
                        calorieën eten dan je verbrand. Dit dien je te doen op
                        een realistische en duurzame manier om je resultaten
                        blijvend te houden. Hierin spelen gezond eten en genoeg{" "}
                        <a
                            href={route("blogs.fourth")}
                            className="text-we-are-yellow"
                        >
                            bewegen
                        </a>{" "}
                        een belangrijke rol. Het vergroten van je spiermassa
                        heeft daar een bepalende rol in dus zorg ervoor dat je{" "}
                        <a
                            href={route("blogs.thirty-four")}
                            className="text-we-are-yellow"
                        >
                            progressive overload
                        </a>{" "}
                        toepast in je trainingen. Hierdoor blijft spiermassa
                        zich ontwikkelen en zul je een hogere BMR krijgen. Om
                        een lang verhaal kort te maken, trap niet in die moderne
                        marketing en let op je eten en blijft voldoende bewegen!
                        Geen ‘cool’ antwoord maar wel de waarheid.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        ‘Als ik dan vet omzet naar spier,lukt het dan?’ Hierover
                        meer in{" "}
                        <a
                            href={route("blogs.sixth")}
                            className="text-we-are-yellow"
                        >
                            deze blog
                        </a>{" "}
                        over het omzetten van vet naar spieren.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
